module.exports = __webpack_public_path__ + "media/spa/person_searching-f5f30347.svg";